import { render, staticRenderFns } from "./DefinitionList.vue?vue&type=template&id=1cd960fe&"
import script from "./DefinitionList.js?vue&type=script&lang=js&"
export * from "./DefinitionList.js?vue&type=script&lang=js&"
import style0 from "./DefinitionList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports